
import React, { useEffect, useState } from "react";
import { Tabs, Popover } from "antd";
import { AntInput } from "../../../../../shared/widges/antinput";
import { CoreServices } from "../../../../../base/service/apiServices";
import { GetItemFromStorage } from "../../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../../custom_hooks/localStorageKeys";
import { useSelector } from "react-redux";
import styles from '../chatMainInner.module.scss';
import { WtButton } from "../../../../../shared/widges/Button/button";
import { PRIVILLEGED_ROLES, ROLES } from "../../../../../base/constant";
import { ChatState } from "../../../../../base/models/model";


const Transfer = (props: any) => {
    const loginUserCcaasDetail = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
    const agentUserList: any = useSelector((state: any) => state.userList);
    const { users } = agentUserList;
    const [agentList, setAgentList] = useState<any>({ agentData: [], dummyData: [] })
    const [popoverVisible, setPopoverVisible] = useState(false);
    const chatReducer: ChatState = useSelector((state: any) => state.chatReducer.currentSession);
    const handlePopoverVisibleChange = (visible: any) => {
        setPopoverVisible(visible);
    };

    useEffect(() => {
        getAgentList()
    }, [])
    const getAgentList = () => {
        if (roleId == ROLES.AGENT_ROLE_ID) {
            CoreServices.get(`/get_agent_supervisor_activity`)
                .then((res: any) => {
                    if (res && res.data.statusCode === 200) {
                        const data = res.data.getAgentList
                        const agent: any = []
                        for (let agent_data of data) {
                            let json_data = { ...agent_data }
                            if (loginUserCcaasDetail?.UserID !== agent_data?.UserID)
                                agent.push(json_data)
                        }
                        setAgentList({ agentData: agent, dummyData: agent })
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            CoreServices.get(`/get_agent_activity`)
                .then((res: any) => {
                    if (res && res.data.statusCode === 200) {
                        const data = res.data.getUserListNumber.filter((row: any) => row.roleid !== loginUserCcaasDetail.roleid)
                        const agent: any = []
                        for (let agent_data of data) {
                            let json_data = { ...agent_data }
                            if (loginUserCcaasDetail?.UserID !== agent_data?.UserID)
                                agent.push(json_data)
                        }
                        setAgentList({ agentData: agent, dummyData: agent })
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };
    const agentsWithEmail = [] as any;
    let filteredAgentsEmail = [] as any;
    const agentsWithSms = [] as any;
    let filteredAgentsSms = [] as any;
    const agentsWithSocialMedia = [] as any;
    
    users.forEach((user: { email: any; sms: any; socialMedia: any; isChatTransfer_AgentStatus: any; isChat: any; ext :any}) => {
        if (user.email) agentsWithEmail.push(user);
        if (user.sms) agentsWithSms.push(user);
        if (user.socialMedia && parseInt(user.ext) !== parseInt(loginUserCcaasDetail?.ext)) agentsWithSocialMedia.push(user);
    });

//     const handlePopoverVisibleChange = (visible: boolean) => {
//     setPopoverVisible(visible);

//     if (visible) {
//         document.body.style.overflow = 'hidden';
//     } else {
//         document.body.style.overflow = '';
//     }
// };
    return (
        <Popover className='agentransfer'  
            content={
                <div>
                    <div className={styles.assigneeslist}>
                        <div className={styles.ppHeader}>
                            <span className={styles.title}>Agent Transfer</span>
                            <span className="icon__Close16" onClick={() => setPopoverVisible(false)} />
                        </div>

                        <div className={`${styles.assignees}`}>
                            <div className={styles.topSearch}>
                                <AntInput
                                    className="tableSearch tableSearchnew mediatransferinputsearch"
                                    placeHolder="Search"
                                    onChange={(evt: any) => {
                                        if (evt.target.value !== '') {
                                            const agent_data = agentList.agentData.filter((obj: any) => {
                                                const values = Object.values(obj).map((value: any) => value.toString().toLowerCase());
                                                return values.some(value => value.includes(evt.target.value.toLowerCase()));
                                            });
                                            setAgentList({ ...agentList, dummyData: agent_data })
                                        } else {
                                            setAgentList({ ...agentList, dummyData: agentList.agentData })
                                        }
                                    }}
                                />
                            </div>
                            <div className={`scroller ${styles.userDt}`}>

                                {
                              (chatReducer?.channelType === "Email" || chatReducer?.EmailHistoryId != null) ? (
                                // console.log('Agents with Email:', agentsWithEmail),
                                filteredAgentsEmail = agentsWithEmail?.filter(
                                    (agent: any) => agent?.ext !== loginUserCcaasDetail?.ext
                                  ),
                                  filteredAgentsEmail?.map((data: any, idx: any) => (
                                    <React.Fragment key={idx}>
                                        <div className={styles.assigneesrow} key={idx}
                                            onClick={() => {
                                                setPopoverVisible(false);
                                                props.agentTransfer(data);
                                            }}
                                        >
                                            {data?.statusName === "Ready" && (
                                                <div className={`${styles.dot} ${styles.ready}`}></div>
                                            )}
                                            {data?.statusName === "Not Ready" && (
                                                <div className={`${styles.dot} ${styles.notready}`}></div>
                                            )}
                                            {data?.statusName === "Offline" && (
                                                <div className={`${styles.dot} ${styles.offline}`}></div>
                                            )}
                                            {data?.statusName === "Away" && (
                                                <div className={`${styles.dot} ${styles.away}`}></div>
                                            )}
                                            {data?.statusName === "Busy" && (
                                                <div className={`${styles.dot} ${styles.busy}`}></div>
                                            )}
                                            {data?.statusName === "Transfer Only" && (
                                                <div className={`${styles.dot} ${styles.transferonly}`}></div>
                                            )}
                                            {data?.statusName === "vacation" && (
                                                <div className={`${styles.dot} ${styles.vacation}`}></div>
                                            )}
                                            <div className={styles.tranfernamelists}>{data?.UserName}<span>{data?.statusName}</span></div>
                                        </div>
                                    </React.Fragment>
                                ))
                            ) 
                                :
                                ( chatReducer?.channelType == "Sms" ||  chatReducer?.SMSHistoryId != null  ) ?(
                                    // console.log('Agents with Sms:', agentsWithSms),
                                    filteredAgentsSms = agentsWithSms?.filter(
                                        (agent: any) => agent?.ext !== loginUserCcaasDetail?.ext
                                      ),
                                      filteredAgentsSms?.map((data: any, idx: any) => (
                                    <React.Fragment key={idx}>
                                        <div className={styles.assigneesrow} key={idx}
                                            onClick={() => {
                                                setPopoverVisible(false);
                                                props.agentTransfer(data)
                                            }}
                                        >
                                            {data?.statusName === "Ready" && (
                                                <div className={`${styles.dot} ${styles.ready}`}></div>
                                            )}
                                            {data?.statusName === "Not Ready" && (
                                                <div className={`${styles.dot} ${styles.notready}`}></div>
                                            )}
                                            {data?.statusName === "Offline" && (
                                                <div className={`${styles.dot} ${styles.offline}`}></div>
                                            )}
                                            {data?.statusName === "Away" && (
                                                <div className={`${styles.dot} ${styles.away}`}></div>
                                            )}
                                            {data?.statusName === "Busy" && (
                                                <div className={`${styles.dot} ${styles.busy}`}></div>
                                            )}
                                            {data?.statusName === "Transfer Only" && (
                                                <div className={`${styles.dot} ${styles.transferonly}`}></div>
                                            )}
                                            {data?.statusName === "vacation" && (
                                                <div className={`${styles.dot} ${styles.vacation}`}></div>
                                            )}
                                            <div className={styles.tranfernamelists}>{data?.UserName}<span>{data?.statusName}</span></div>
                                        </div>
                                    </React.Fragment>
                                    )))
                                :
                                agentsWithSocialMedia?.map((data: any, idx: any) => (
                                    <React.Fragment key={idx}>
                                        <div className={styles.assigneesrow} key={idx}
                                            onClick={() => {
                                                console.log("isChatTransfer_AgentStatus >>>",data?.isChatTransfer_AgentStatus === 1 ,  data.isChat === 1)
                                                if(data?.isChatTransfer_AgentStatus === 1 || data.isChat === 1){
                                                    setPopoverVisible(false);
                                                    props.agentTransfer(data)
                                                }
                                            }}
                                        >
                                            {data?.statusName === "Ready" && (
                                                <div className={`${styles.dot} ${styles.ready}`}></div>
                                            )}
                                            {data?.statusName === "Not Ready" && (
                                                <div className={`${styles.dot} ${styles.notready}`}></div>
                                            )}
                                            {data?.statusName === "Offline" && (
                                                <div className={`${styles.dot} ${styles.offline}`}></div>
                                            )}
                                            {data?.statusName === "Away" && (
                                                <div className={`${styles.dot} ${styles.away}`}></div>
                                            )}
                                            {data?.statusName === "Busy" && (
                                                <div className={`${styles.dot} ${styles.busy}`}></div>
                                            )}
                                            {data?.statusName === "Transfer Only" && (
                                                <div className={`${styles.dot} ${styles.ready}`}></div>
                                            )}
                                            {data?.statusName === "vacation" && (
                                                <div className={`${styles.dot} ${styles.vacation}`}></div>
                                            )}
                                            <div className={styles.tranfernamelists}>{data?.UserName}<span>{data?.statusName}</span></div>
                                        </div>
                                    </React.Fragment>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                </div >
            }
            trigger="click"
            overlayClassName="editshortcut transfercall"
            open={popoverVisible}
            onOpenChange={handlePopoverVisibleChange}
            getPopupContainer={() => document.body}
            placement="bottomRight" >
            <span className={styles.astArea}>
                <WtButton className="btnGreenText" name="Transfer" />
            </span>
        </Popover>
    )
}

export default Transfer